import slice from './slice';
import * as _selectors from './selectors';
export { epics } from './epics';

export const selectors = { ..._selectors };
export const actions = slice.actions;
export const reducer = slice.reducer;
